import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-recommendation-category-dialog.controller';
import template from './edit-recommendation-category-dialog.html';
import validator, { name as validatorName } from '../messages/recommendation-category-unique-name.validator.directive';
import nameTpl from '../messages/recommendation-category.name.messages.html';

// import notesTpl from '../validation/recommendation-category.notes.messages.html'; <-- missing template!


class dialogService {
  getOptions($event, { recommendationCategory }) {
    return {
      controller,
      controllerAs: 'editRecommendationCategoryDialogVM',
      locals: {
        recommendationCategory
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editRecommendationCategoryDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .controller()
  .directive(validatorName, validator)
  .service('editRecommendationCategoryDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('recommendation-category.name.messages.html', nameTpl);
    // $templateCache.put('recommendation-category.notes.messages.html', notesTpl);
  })
  .name;
